import { render, staticRenderFns } from "./TeacherWelcome.vue?vue&type=template&id=ef8bdc42&scoped=true"
import script from "./TeacherWelcome.vue?vue&type=script&lang=js"
export * from "./TeacherWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8bdc42",
  null
  
)

export default component.exports